module.exports = __webpack_public_path__ + "static/img/thumb_12.575bb58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_12.jpg
// module id = WjJn
// module chunks = 0